<template>
    <div>
        <DTabs class="mb-3">
            <DTabItem
                id="import"
                :active="['tools.providerbox.import-index'].includes($route().current())"
                :label="__('tools.providerbox.tabs.import')"
                :route-url="$route('tools.providerbox.import')"
            />
            <DTabItem
                id="imported-items"
                :active="['tools.providerbox.imported-items'].includes($route().current())"
                :label="__('tools.providerbox.tabs.imported_items')"
                :route-url="$route('tools.providerbox.imported-items')"
            />
            <DTabItem
                id="invoices"
                :active="['tools.providerbox.invoices-index'].includes($route().current())"
                :label="__('tools.providerbox.tabs.invoices')"
                :route-url="$route('tools.providerbox.invoices-index')"
            />
        </DTabs>

        <ImportIndex
            v-if="['tools.providerbox.import-index'].includes($route().current())"
            :modules="modules"
            :customer-types="customerTypes"
            :import-history="importHistory"
            :errors="errors"
        />
        <ImportedItemsIndex
            v-if="['tools.providerbox.imported-items'].includes($route().current())"
            :imported-items="importedItems"
            :modules="modules"
            :status="status"
            :filters="filters"
        />
        <InvoicesIndex
            v-if="['tools.providerbox.invoices-index'].includes($route().current())"
            :invoices="invoices"
            :modules="modules"
            :filters="filters"
        />
    </div>
</template>

<script>
import ImportIndex from '~@/Components/Tools/Providerbox/ImportIndex'
import ImportedItemsIndex from '~@/Components/Tools/Providerbox/ImportedItemsIndex'
import InvoicesIndex from '~@/Components/Tools/Providerbox/InvoicesIndex'

export default {
    name: 'ProviderboxTabs',
    components: {
        InvoicesIndex,
        ImportIndex,
        ImportedItemsIndex
    },
    props: {
        tab: {
            type: String,
            default: ''
        },
        modules: {
            type: Array,
            default: () => { return [] }
        },
        status: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        invoices: {
            type: Array,
            default: () => { return [] }
        },
        importHistory: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        importedItems: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => {
                return {
                    dateTo: null,
                    dateFrom: null,
                    modules: [],
                    status: null,
                    customerId: null
                }
            }
        }
    }
}
</script>
<style scoped>

</style>
